export function getNewTranslationFile(callback){
    const xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function() {

        if (xmlHttp.readyState === 4 && xmlHttp.status === 200){
            const newTranslation = JSON.parse(xmlHttp.responseText.replace("window.translation=", ""));
            window.translation = newTranslation;
            callback();
        }
    };
    xmlHttp.open("GET", "/PHP/LOGO_QUIZ/php/language.php", true); // true for asynchronous
    xmlHttp.send(null);
}